import { Pcategory } from './pcategory';
import { Filters } from '../helpers/filters';
import { Utils } from '../helpers/utils';
import { environment } from '../../../environments/environment';

export class DmenuTranslation {
	id: number;
	lang: 'en'|'pt'|'de'|'jp'|'cn'|'es'|'fr'|'ru'|'it';
	dmenu_id: number;
	name: string;
	description: string;
}
export class Dmenu {
	id: number;

	company_id: number;
	company_name: string;
	local_id: number;

	name: string;
	description: string;
	order: string; // {digital_menu: 0}

	hidden: boolean;

	picture: {
		url: string
	};

	pcategories: Pcategory[];
  dmenu_translations: DmenuTranslation[];

  schedule: string;

	created_at: string;
	updated_at: string;

	// set by our front end app
	parsedOrder: {
		digital_menu: number, // 0 is lowest. defaults to 0
		delivery: number,
		prices: true|false // defaults to true
	};
	parsedSchedule: {
		[day_of_week: string]: string[]
	};
	isOnSchedule: boolean;
  final_picture_path: string;
  final_mini_picture_path: string;

	selected: boolean;
  deliveryOrder: number;
  digitalMenuOrder: number;
  translatedName: string;
  translatedDescription: string;

  // given by our back-end app
  aws_picture_path: string;
  aws_mini_picture_path: string;

	static setAdditionalData(dmenu: Dmenu) {
		dmenu.isOnSchedule = true;

		if(dmenu.order){
			dmenu.parsedOrder = JSON.parse(dmenu.order);
		}
		else {
			dmenu.parsedOrder = {
				digital_menu: 0,
				delivery: 0,
				prices: true
			}; 
		}
		
		dmenu.deliveryOrder = dmenu.parsedOrder.delivery || 0;
		dmenu.digitalMenuOrder = dmenu.parsedOrder.digital_menu || 0;

		dmenu.translatedName = dmenu.name;
		dmenu.translatedDescription = dmenu.description;

		if(dmenu.schedule){
			dmenu.parsedSchedule = JSON.parse(dmenu.schedule);
			dmenu.isOnSchedule = Dmenu.checkSchedule(dmenu) != 'closed';
		}

    // set final picture path
    if(dmenu.aws_picture_path) {
      dmenu.final_picture_path = dmenu.aws_picture_path;
    } else {
      if(dmenu.picture && dmenu.picture.url) {
        dmenu.final_picture_path = environment.server_url + dmenu.picture.url;
      } else {
        dmenu.final_picture_path = environment.server_url + "/default.png";
      }
    }
    // set final mini picture path
    if(dmenu.aws_mini_picture_path) {
      dmenu.final_mini_picture_path = dmenu.aws_mini_picture_path;
    } else {
      if(dmenu.picture && dmenu.picture.url) {
        let paths = dmenu.picture.url.split("/");
        let filename = paths[paths.length - 1];
        paths[paths.length - 1] = "mini_" + filename;
        dmenu.final_mini_picture_path = environment.server_url + paths.join("/");
      } else {
        dmenu.final_mini_picture_path = environment.server_url + "/default.png";
      }
    }
	}
  static setArrayAdditionalData(dmenus: Dmenu[]) {
    for(let dmenu of dmenus) {
      Dmenu.setAdditionalData(dmenu);
    }
  }
  static sortByDisplayOrder(dmenus: Dmenu[], mode: 'delivery'|'digital_menu', showHidden: boolean = true): Dmenu[] {
    Dmenu.setArrayAdditionalData(dmenus);

    if(!showHidden) {
    	let aux = [];
    	for(let dmenu of dmenus) {
    		if(!dmenu.hidden && Dmenu.checkSchedule(dmenu) != 'closed') {
    			aux.push(dmenu);
    		}
    	}
    	dmenus = aux;
    }

    let res = [];
    if(mode == 'delivery') {
      return Filters.orderAlphabetically(dmenus, 'deliveryOrder').reverse();
    } else {
      return Filters.orderAlphabetically(dmenus, 'digitalMenuOrder').reverse();
    }
  }
  static availableLangs(dmenus: Dmenu[]): string[] {
  	let res = [];
  	for(let dmenu of dmenus) {
  		if(dmenu.dmenu_translations && dmenu.dmenu_translations.length > 0) {
  			for(let translation of dmenu.dmenu_translations) {
  				Utils.pushIfNotExists(res, translation.lang);
  			}
  		}
  	}

  	return res;
  }

  // 'lang' is the language abreviation, like 'pt', 'en', 'es', ...
  static translate(dmenus: Dmenu[], lang: string) {
  	if(dmenus == null)
  		return;
  	
  	for(let dmenu of dmenus) {
  		if(lang == null) {
  			dmenu.translatedName = dmenu.name;
  			dmenu.translatedDescription = dmenu.description;
  		} else {
	  		for(let translation of dmenu.dmenu_translations) {
	  			if(lang == translation.lang) {
	  				dmenu.translatedName = translation.name;
	  				dmenu.translatedDescription = translation.description;
	  			}
	  		}
  		}
  	}
  }


	static checkSchedule(dmenu: Dmenu): 'closed'|'open'|'closing'|'opening' {
		if(!dmenu.schedule)
			return 'open';

		if(!dmenu.parsedSchedule)
			Dmenu.setAdditionalData(dmenu);

		let aux = Utils.isOnSchedule(dmenu.parsedSchedule, 30, 30);

		return aux.status;
	}
}